module.exports = __webpack_public_path__ + "static/media/carousel-3.dd343f23.jpg";